<!-- Along the top while anything loads or saves, on every page. -->
<app-http-progress></app-http-progress>
<router-outlet></router-outlet>
<!-- Toasts live at the root so they show on the login page too. -->
<app-toast-host></app-toast-host>
